'use client';

import { BASE_URL } from '@/common/constants';
import Link from 'next/link';
import { ClockCircleOutlined } from '@ant-design/icons';
import get from 'lodash/get';
import { checkType, formatDateVN } from '@/common/ultils';
import Image from 'next/image';

const CategoryNewsBlockHome = ({ slug, item, websiteCode, deviceType }) => {
  const handleSubmitUpView = async (id) => {
    try {
      await fetch(`${BASE_URL}/showcaseWalls/updateViews/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });
    } catch {
      // alert(`Có lỗi xảy ra! ${error}`);
    }
  };

  const mainPosts = get(item, 'postss[0]');
  const smallPostss = get(item, 'postss', []).slice(1, 5);
  return (
    <div className="border border-[#0000000f] rounded bg-white vb-moi relative">
      {/* <CardItemHomeQHPage
        header={
          <h3
            onClick={() => {
              setSelectedCategory(item);
              handleSubmitUpView(item?.id);
            }}
            className={`text-[15px] font-bold ${titleColor} flex items-center uppercase cursor-pointer`}>
            {item?.name}
          </h3>
        }></CardItemHomeQHPage> */}
      <div
        className="title cursor-pointer"
        onClick={() => {
          handleSubmitUpView(item?.id);
        }}>
        <a href={`/${websiteCode ? `sub/${websiteCode}/` : ''}chuyen-muc/${item.slug}`} className="font-normal w-full">
          {item?.name}
        </a>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 p-3">
        {mainPosts && (
          <div className="w-full ">
            <div className="flex justify-between items-start ">
              <Link href={`${slug}/${mainPosts.slug}`} className="mr-3">
                {mainPosts?.imgaeUrls ? (
                  <div className="relative bg-gray-100 h-[70px] w-[90px] mb-2 rounded flex items-center justify-center text-gray-500 text-sm overflow-hidden">
                    <Image
                      src={checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', mainPosts, -1)}
                      alt={mainPosts.title}
                      className="rounded object-cover hover:scale-105 transition-transform duration-300 position-initial"
                      fill
                      quality={85}
                    />
                    {/* <img
                      src={checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', mainPosts, -1)}
                      alt={mainPosts.title}
                      className="rounded w-full h-full hover:scale-105 transition-transform duration-300"
                    /> */}
                  </div>
                ) : (
                  <div className="relative bg-gray-100 h-[70px] w-[90px] mb-2 p-3 rounded flex items-center justify-center text-gray-500 text-sm">
                    <Image src={`/img-default.png`} alt="Ảnh mặc định" width={50} height={50} className="rounded object-cover" sizes="50px" />
                  </div>
                )}
              </Link>

              <div className="flex-1">
                <Link href={`${slug}/${mainPosts.slug}`} className="group">
                  <p className="font-semibold text-base group-hover:text-red-600 line-clamp-2">{mainPosts.title}</p>
                </Link>
                <div className="font-light! text-xs mt-3 text-gray-600 ">
                  <ClockCircleOutlined className="mr-1" />
                  {!!(mainPosts?.postedDate ?? mainPosts?.date) ? formatDateVN(mainPosts?.postedDate ?? mainPosts?.date) : ''}
                </div>
              </div>
            </div>
            <div
              className=" text-sm text-gray-600 group-hover:text-red-600 line-clamp-3 font-normal!"
              dangerouslySetInnerHTML={{ __html: mainPosts?.summary }}
            />
            {smallPostss.length > 0 && (
              <ul className="space-y-2 grow sm:mt-0 list-none pl-0 mt-2! border-t border-dotted border-gray-300 pt-2">
                {smallPostss.map((article) => (
                  <li key={article.slug} className="text-sm leading-tight flex items-start pb-2 border-b border-dotted border-gray-300 icon-namdinh">
                    <div className="line-clamp-2 leading-5">
                      <Link href={`${slug}/${article.slug}`} className="hover:text-red-600 hover:underline">
                        {article.title}
                      </Link>
                      <span className="ml-1 text-[11px] font-extralight italic text-gray-600">
                        ({!!(article?.postedDate ?? article?.date) ? formatDateVN(article?.postedDate ?? article?.date) : ''})
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryNewsBlockHome;

